const populateDateAndTimeFormFields = () => {

	// Query elements and data
	const slots = window.callbackDateAvailableSlots;

	const dateSelect = document.querySelector('.js-callback-date-select');
	const timeSelect = document.querySelector('.js-callback-time-select');

	if (!dateSelect || !timeSelect) {
		return;
	};

	const dateSelectDefault = dateSelect.dataset.defaultValue;
	const timeSelectDefault = timeSelect.dataset.defaultValue;


	// let selectedDate = null;

	// get tthe select box, and create html options for each of the dates in `payload`, then
	// set innherHTML on selectbox to be the giant html string of all the options

	const createDateOptionHtml = (date) => {
		return `<option value="${date.date}">${date.label}</option>`;
	};

	const createDefaultDateOption = () => {
		return `<option value="" selected>${dateSelectDefault}</option>`;
	};

	const createTimeOptionHtml = (time) => {
		return `<option value="${time.time}">${time.label}</option>`;
	};

	const createDefaultTimeOption = () => {
		return `<option value="" selected>${timeSelectDefault}</option>`;
	};

	dateSelect.innerHTML = [createDefaultDateOption()].concat(slots.map(createDateOptionHtml)).join('');
	timeSelect.disabled = true;



	dateSelect.addEventListener('change', () => {
		// find the first item that matches the condition in the payload array
		// the condition is checking whether date property is the same as the currently selected value
		// allows us to now grab the array of times for the selected value/object
		const selectedDate = slots.find((date) => date.date === dateSelect.value);

		if (!selectedDate) {
			timeSelect.disabled = true;
			timeSelect.innerHTML = '';
			return;
		}

		timeSelect.disabled = false;
		timeSelect.innerHTML = [createDefaultTimeOption()].concat(selectedDate.times.map(createTimeOptionHtml)).join('');
	});
}

const observerCallback = (mutationsList, observer) => {
	for (const mutation of mutationsList) {
		if (mutation.type === 'attributes') {
			const node = mutation.target;
			if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('js-callback-time-select')) {
				updateTimeSlotDisabledState(node);
			}
		}
	}
}
 
const formContainer = document.querySelector('[data-sf-role="form-container"]');
if (formContainer) {
	const observer = new MutationObserver(observerCallback);
	const observerConfig = { attributes: true, subtree: true, childList: true };
	observer.observe(formContainer, observerConfig);
}

function updateTimeSlotDisabledState(node) {
	const dateSelect = document.querySelector('.js-callback-date-select');
	if (!dateSelect) {
		return;
	}

	if (dateSelect.value !== '' && node.disabled) {
		node.disabled = false;
		node.removeAttribute('disabled');
	} else if (dateSelect.value === '' && !node.disabled) {
		node.disabled = true;
		node.setAttribute('disabled', 'disabled');
	}
}

populateDateAndTimeFormFields();
